import {fetchAndDeserialize} from '../../../util/api-adapter';
import {objectToUrlParameters} from '../../../util/url';
import {ReviewsAndAnswersFilterStateType} from '../filter/reviews-and-answers-statistics-filter-type';
import {reviewsAndAnswersApiFilterValues} from '../filter/reviews-and-answers-statistics-helper';

import {reviewsCountByRatingSchema, ReviewsCountByRatingType} from './reviews-count-by-rating-type';

export function fetchReviewsCountByRating(
    filter: ReviewsAndAnswersFilterStateType,
    mainFilterKey: string
): Promise<ReviewsCountByRatingType> {
    return fetchAndDeserialize(
        `/cp/reviews/statistics/by_rating/?${objectToUrlParameters(
            reviewsAndAnswersApiFilterValues(filter, mainFilterKey)
        )}`,
        reviewsCountByRatingSchema
    );
}
